









































import { AddPolicyIndividualDTO, ClientPolicyDto, PolicyIndividualDTO, SyncPolicyIndividualResponseDTO } from '@core/pages/new-business-register/api'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import PolicyIndividualSection from '../PolicyIndividualSection.vue'
import PolicyIndividualDetailSection from '../PolicyIndividualDetailSection.vue'
import TheAddPolicyIndividualModal from '../../policy-individual/TheAddPolicyIndividualModal.vue'
import { SharedVariable } from '@core/model/SharedVariable'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import AddPolicyIndividual from '../../policy-individual/model/AddPolicyIndividualDTO'
import { IDateService } from '@master/services/IDateService'

const clientPolicyStore = namespace('ClientPolicyStore')
const clientStore = namespace('ClientStore')

@Component({
  components: {
    PolicyIndividualSection,
    PolicyIndividualDetailSection,
    TheAddPolicyIndividualModal
  }
})
export default class PolicyIndividualPage extends Vue {
  @clientPolicyStore.State
  private policy: ClientPolicyDto

  @clientPolicyStore.State
  private policyIndividuals: PolicyIndividualDTO[]

  @clientPolicyStore.State
  private policyRoles

  @clientStore.State
  private clientList

  @clientPolicyStore.State
  private relationshipOptions

  @clientPolicyStore.State
  private identityTypeOptions

  @clientPolicyStore.State
  private citizenshipOptions

  @clientPolicyStore.State
  private maritalStatusOptions

  @clientPolicyStore.State
  private eduLevelOptions

  @clientPolicyStore.State
  private spokenLangOptions

  @clientPolicyStore.State
  private writtenLangOptions

  @clientPolicyStore.State
  private incomeTierOptions

  @clientPolicyStore.State
  private syncClientResponse: SyncPolicyIndividualResponseDTO

  @clientPolicyStore.Action
  private fetchPolicyIndividuals

  @clientPolicyStore.Action
  private savePolicyIndividual

  @clientPolicyStore.Action
  private syncClientInformation

  @clientPolicyStore.Action
  private deletePolicyIndividual

  @clientPolicyStore.Action
  private addPolicyIndividual

  @clientStore.Action
  private retrieveClientList

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private dateService: IDateService

  private selectedIndividual = null
  private showAddPolicyIndDialog = false
  private addIndividual = new AddPolicyIndividual()

  async mounted () {
    this.uiService = this.sharedVariable.uiService
    await this.retrieveClientList()
  }

  openAddDialog (value: boolean) {
    this.showAddPolicyIndDialog = value
    this.addIndividual = new AddPolicyIndividual()
  }

  openClientInfo (policyIndividual: PolicyIndividualDTO) {
    const clientInfoUrl = this.$router.resolve({ path: `/client-info/${policyIndividual.clientOid}/profile` })
    window.open(clientInfoUrl.href, '_blank')
  }

  get isAllActionDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get filteredRoleOptions () {
    return this.policyRoles
  }

  // Policy Individuals functions

  async syncIndividual (individual: PolicyIndividualDTO) {
    await this.syncClientInformation({
      policyIndividualOid: individual.oid,
      checkIfInPast: true
    })
    const { isSyncOlderThanCurrent, isThisUpdatedThanClient } = this.syncClientResponse
    const message = isThisUpdatedThanClient ? 'The current information is newer than client, do you wish to continue syncing from client?' : 'There is newer information from client, continue to sync?'
    if (!isSyncOlderThanCurrent) {
      this.uiService.alert.show({
        message: 'Information has already been synced to latest.',
        type: 'warning'
      })
      return
    }
    const confirmation = await this.uiService.confirm.show({
      message,
      type: 'warning'
    })

    if (confirmation) {
      await this.syncClientInformation({
        policyIndividualOid: individual.oid,
        checkIfInPast: false
      })
      const { isSynced } = this.syncClientResponse
      if (isSynced) {
        this.uiService.alert.show({
          message: 'Entity / Individual has been synced.',
          type: 'success'
        })
      }
    }
  }

  async addPolicyIndividualToPolicy (individualDTO: AddPolicyIndividualDTO) {
    individualDTO.policyOid = this.policy.oid
    const result = await this.addPolicyIndividual(individualDTO)
    this.showAddPolicyIndDialog = false
    if (result) {
      await this.fetchPolicyIndividuals(this.policy.oid)
      this.uiService.alert.show({
        type: 'success',
        message: 'Added entity / individual into policy!.'
      })
    }
  }

  async saveIndividual (individual: PolicyIndividualDTO) {
    const updatedIndividual = await this.savePolicyIndividual(individual)
    if (updatedIndividual) {
      const name = individual.clientDataSnapshot.clientId || individual.clientDataSnapshot.name
      this.uiService.alert.show({
        type: 'success',
        message: `Updated ${name}.`
      })
    }
  }

  async deleteIndividual (individual: PolicyIndividualDTO) {
    const name = individual.clientDataSnapshot.clientId || individual.clientDataSnapshot.name
    const isConfirm = await this.uiService.confirm.show({
      type: 'warning',
      message: `Are you sure to delete ${name} from this product?`
    })
    if (isConfirm) {
      const deleted = await this.deletePolicyIndividual(individual)
      await this.fetchPolicyIndividuals(this.policy.oid)
      this.selectedIndividual = null

      if (deleted) {
        this.uiService.alert.show({
          type: 'success',
          message: `Deleted ${name}.`
        })
      }
    }
  }

  displayPolicyIndividual (individual) {
    this.selectedIndividual = individual
  }
}
